import { TYPE_UK_ADDRESS, RADIO_VALUE_NO, RADIO_VALUE_YES } from '../../../utils/constants';

export const RESIDENTIAL_STATUS_OTHER_DATA = [
  { id: 'LIVING WITH FRIENDS', labelText: 'Living with friends' },
  { id: 'LEASEHOLD', labelText: 'Leasehold' }
];

export const PERSONAL_TITLE_OTHER_DATA = [
  { id: 'Ms', labelText: 'Ms' },
  { id: 'Master', labelText: 'Master' },
  { id: 'Dr', labelText: 'Dr' },
  { id: 'Lady', labelText: 'Lady' },
  { id: 'Lord', labelText: 'Lord' },
  { id: 'Prof', labelText: 'Prof' },
  { id: 'Rev', labelText: 'Rev' },
  { id: 'Sir', labelText: 'Sir' }
];

export const REGULAR_TITLES = ['Mr', 'Miss', 'Mrs'];

export const RESIDENTIAL_STATUS_KEYS = [
  { value: 'LIVING WITH FRIENDS', label: 'Living with friends' },
  { value: 'LEASEHOLD', label: 'Leasehold' },
  { value: 'OWNER', label: 'Owner' },
  { value: 'TENANT PRIVATE', label: 'Renting from private landlord' },
  {
    value: 'TENANT PUBLIC',
    label: 'Renting from council or housing association'
  },
  { value: 'LIVING WITH PARENTS', label: 'Living with parents' }
];
export const OTHER_TITLE = [
  { value: 'Ms', label: 'Ms' },
  { value: 'Master', label: 'Master' },
  { value: 'Dr', label: 'Dr' },
  { value: 'Lady', label: 'Lady' },
  { value: 'Lord', label: 'Lord' },
  { value: 'Prof', label: 'Prof' },
  { value: 'Rev', label: 'Rev' },
  { value: 'Sir', label: 'Sir' }
];

export const clearFormFields = formValues => {
  if (formValues.authorisedSignatory === 'Yes') {
    if (!formValues.percentPersonOwnCompany) {
      delete formValues.percentPersonOwnCompany;
    }
  }
};

export const updateOnCompamyDirectorChanges = values => {
  delete values.companyDirector;
  delete values.ownCompany;
  delete values.percentPersonOwnCompany;
  deleteAddressValues(values);
};

export const updateOnOwnCompanyChange = values => {
  delete values.companyDirector;
  delete values.percentPersonOwnCompany;
  deleteAddressValues(values);
};

export const isCardError = (values, isSoleTrader) => {
  if (isSoleTrader && values.authorisedSignatory === 'No') {
    return true;
  } else if (
    !isSoleTrader &&
    values.authorisedSignatory === 'No' &&
    values.ownCompany === RADIO_VALUE_NO
  ) {
    return true;
  }
  return false;
};

const deleteAddressValues = values => {
  Object.keys(values).filter(v => {
    if (v.indexOf(TYPE_UK_ADDRESS) > -1) {
      delete values[v];
      return false;
    }
    return true;
  });
};

export const getShareHolderPercentage = (ownCompany, percentage, underPercentage) => {
  if (ownCompany === RADIO_VALUE_YES) {
    return percentage;
  }
  return underPercentage;
};
